var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAmountDue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.001,
    height: 14.001,
    viewBox: "0 0 14.001 14.001",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M12262,14a7,7,0,1,1,7-7A7.01,7.01,0,0,1,12262,14Zm-2.5-5.139h0l-.478,1.074a4.7,4.7,0,0,0,2.605.884V12h.874V10.808c1.521-.154,2.467-.993,2.467-2.189,0-1.423-1.167-1.824-2.467-2.14V4.329a4.446,4.446,0,0,1,1.722.576l.438-1.075a4.555,4.555,0,0,0-2.159-.65V2h-.874V3.2c-1.509.146-2.445.985-2.445,2.192,0,1.431,1.157,1.833,2.445,2.149V9.672a4.117,4.117,0,0,1-2.128-.81Zm3,.789h0V7.766c.575.164,1.105.393,1.105.948,0,.5-.393.828-1.1.936Zm-.874-3.393h0c-.558-.165-1.074-.391-1.074-.926,0-.516.382-.859,1.075-.967V6.255Z",
    transform: "translate(-12254.999)",
    fill: "#727272"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAmountDue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-amount-due.77faac318b1107bba43e291375c62ed2.svg";